module.exports = __webpack_public_path__ + "static/img/logo.a88910cc.png";